import { Tooltip, Typography } from "@mui/material";
import React from "react";

import { Button, TrashIcon } from "@coolset/cs-ui";

export const CellBlockFormHeader: React.FC<CellBlockFormHeaderProps> = (props) => {
  const { onDeleteBlock } = props;

  return (
    <div className="_d-flex-ali-baseline-jc-sb-sm-gap">
      <Typography variant="h3">Cell</Typography>
      <Tooltip title="Clear cell content">
        <Button variant="outlined" onClick={onDeleteBlock}>
          <TrashIcon />
        </Button>
      </Tooltip>
    </div>
  );
};

interface CellBlockFormHeaderProps {
  onDeleteBlock: () => void;
}
